/**
 * useRequestWatchers.ts — Hook for the "who's watching this request" feature.
 *
 * Fetches the initial watcher list from GET /requests/{id}/watchers on mount,
 * then the React Query cache is kept live by useThreadSSE which writes
 * watchers_update events under the same query key.
 *
 * Reviewers and PMs receive names; requestors receive count only (names=[]).
 */

import { useQuery } from "@tanstack/react-query";
import { requestsApi } from "@/lib/api";

export function useRequestWatchers(requestId: string | undefined) {
  return useQuery({
    queryKey: ["watchers", requestId],
    queryFn: () => requestsApi.getWatchers(requestId!),
    enabled: !!requestId,
    staleTime: 5_000,
    // Short refetch interval as a backstop in case an SSE event is missed.
    refetchInterval: 30_000,
  });
}
